import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import DateFormat from 'constants/date_format';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const formatDate = (date, format) =>
  moment(date, DateFormat.fixed.ISO8601_LOCAL).format(format);

const SessionTime = ({ startTime, endTime, className, timeZone }) => (
  <div className={classNames('d-f fd-c', className)}>
    <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
      {moment(startTime, DateFormat.fixed.ISO8601_LOCAL).format(
        DateFormat.fixed.LONG_WITH_SHORT_DAY,
      )}
      ,&nbsp;
      {formatDate(startTime, DateFormat.TIME)}&nbsp;
      {t('conjunctions.to')}&nbsp;
      {formatDate(endTime, DateFormat.TIME)}&nbsp; {' | '}{' '}
      {timeZone && (
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>{timeZone}</Text>
      )}
    </Text>
  </div>
);

export default SessionTime;
